import CityPageTemplate from "../city-template/CityPageTemplate";
import { somersetConfig } from "./data";

export default function SomersetPage() {
  return <CityPageTemplate config={somersetConfig} />;
}